export const COMFORT_ARRAY = [
  ["Tylna osłona przeciwwietrzna (Windstop)", "windstop"],
  ["Elektrycznie ustawiany fotel kierowcy", "driver_seat_electrically_adjustable"],
  ["Elektrycznie ustawiany fotel pasażera", "passenger_seat_electrically_adjustable"],
  ["Podgrzewany fotel kierowcy", "heated_seat_driver"],
  ["Podgrzewany fotel pasażera", "heated_seat_passenger"],
  ["Regul. elektr. podparcia lędźwiowego - kierowca", "lumbar_adjust_driver_electric"],
  ["Regul. elektr. podparcia lędźwiowego - pasażer", "lumbar_adjust_passenger_electric"],
  ["Fotele przednie wentylowane", "ventilated_front_seat"],
  ["Fotele przednie z funkcje masażu", "front_seat_with_massage"],
  ["Siedzenie z pamięcią ustawienia", "memory_seat"],
  ["Sportowe fotele - przód", "sport_seats_front"],
  ["Ogrzewane siedzenia tylne", "rear_seat_heating"],
  ["Fotele tylne wentylowane", "ventilated_rear_seat"],
  ["Fotele tylne z funkcje masażu", "rear_seat_with_massage"],
  ["Podłokietniki - przód", "armrest_front"],
  ["Podłokietniki - tył", "armrest_rear"],
  ["Kierownica skórzana", "leather_steering_wheel"],
  ["Kierownica sportowa", "sports_steering_wheel"],
  ["Kierownica ze sterowaniem radia", "steering_wheel_with_radio_operation"],
  ["Kolumna kierownicy regulowana elektrycznie", "steering_wheel_electrically_adjustable"],
  ["Kierownica wielofunkcyjna", "multi_functional_steering_wheel"],
  ["Kierownica ogrzewana", "steering_wheel_heated"],
  ["Zmiana biegów w kierownicy", "steering_wheel_with_gear_switches"],
  ["Dźwignia zmiany biegów wykończona skórą", "leather_gearshifterswitch"],
  ["Cyfrowy kluczyk", "digital_key"],
  ["Keyless entry", "keyless_entry"],
  ["Keyless Go", "keyless_go"],
  ["Uruchamianie silnika bez użycia kluczyków", "keyless_engine_start"],
  ["Ogrzewanie postojowe", "independent_vehicle_heater"],
  ["Automatyczna kontrola ogrzewania", "automatic_heating_control"],
  ["Czujnik deszczu", "rain_sensor"],
  ["Podgrzewana przednia szyba", "windscreen_heating"],
  ["Wycieraczki", "windscreenwiper_other"],
  ["Elektryczne szyby przednie", "power_windows_front"],
  ["Elektryczne szyby tylne", "power_windows_rear"],
  ["Przyciemniane tylne szyby", "tinted_rear_windows"],
  ["Roleta szyby tylnej regulowana elektrycznie", "sunblind_tailgate_window_electric"],
  ["Dach otwierany elektrycznie", "top_electrically_operated"],
  ["Dach otwierany elektrycznie pilotem", "top_remote_controlled"],
].sort((a, b) => a[0].localeCompare(b[0]))

export const SECURITY_ARRAY = [
  ["ABS", "antilock_brake_system"],
  ["ESP", "esp"],
  ["Elektroniczny system rozdziału siły hamowania", "distribution_of_braking_force_electronically"],
  ["System wspomagania hamowania", "power_assisted_brakes"],
  ["Asystent hamowania awaryjnego w mieście", "city_emergency_brake_assist"],
  ["System hamowania awaryjnego dla ochrony pieszych", "pedestrian_emergency_brake_assist"],
  ["Aktywny asystent hamowania awaryjnego", "active_emergency_brake_assist"],
  ["System ostrzegający o możliwej kolizji", "collision_warning_system"],
  ["System ochrony słuchu w przypadku kolizji", "pre_crash_sound_system"],
  ["System chroniący przed kolizja, tylny", "rear_pre_crash_system"],
  ["System chroniący przed kolizja, boczny", "side_pre_crash_system"],
  ["Alarm ruchu poprzecznego z tyłu pojazdu", "rear_cross_traffic_alert"],
  ["System emitujący dźwięk silnika (AVAS)", "acoustic_vehicle_alerting_system"],
  ["System wykrywania zmęczenie kierowcy", "driver_conditioning_monitoring"],
  ["System rekomendacji przerw podczas trasy", "pause_recommendation_warning"],
  ["Aktywny system monitorowania kondycji kierowcy", "active_driver_conditioning_monitoring"],
  ["Asystent pasa ruchu", "active_lane_control_assistant"],
  ["System minimalizujący skutki kolizji", "pre_crash_system"],
  ["System powiadamiania o wypadku", "automatic_emergency_call"],
  ["Poduszka powietrzna kierowcy", "driver_airbag"],
  ["Poduszka powietrzna pasażera", "passenger_airbag"],
  ["Poduszka kolan kierowcy", "knee_airbag_driver"],
  ["Poduszka kolan pasażera", "knee_airbag_passenger"],
  ["Kurtyny powietrzne - przód", "head_airbags_front"],
  ["Poduszka powietrzna centralna", "central_airbag_driver_and_passenger"],
  ["Poduszki powietrzne czołowe - tył", "front_airbags_for_rear_seats"],
  ["Boczna poduszka powietrzna kierowcy", "side_airbag_driver"],
  ["Boczne poduszki powietrzne - przód", "side_airbag_driver_and_passenger"],
  ["Kurtyny powietrzne - tył", "head_airbags_rear"],
  ["Boczne poduszki powietrzne - tył", "side_airbags_rear"],
  ["Kurtyna powietrzna z tyłu, poprzeczna", "rear_transversal_curtain_airbag"],
  ["Poduszka powietrzna pasów bezpieczeństwa", "seat_belt_airbag_rear"],
  ["Isofix (punkty mocowania fotelika dziecięcego)", "child_seat_fixation"],
  ["System zabezpieczający podczas dachowania", "roll_over_protection_system"],
].sort((a, b) => a[0].localeCompare(b[0]))

export const ASSISTANT_ARRAY = [
  ["Kontrola odległości z przodu (przy parkowaniu)", "park_distance_control_front"],
  ["Kontrola odległości z tyłu (przy parkowaniu)", "park_distance_control_rear"],
  ["Park Assistant - asystent parkowania", "park_assistant"],
  ["Niezależny system parkowania", "autonomous_parking_system"],
  ["Kamera panoramiczna 360", "360_view_camera"],
  ["Kamera parkowania tył", "rear_view_camera"],
  ["Lusterka boczne ustawiane elektrycznie", "door_mirror_electrically_adjustable_in_general"],
  ["Podgrzewane lusterka boczne", "door_mirrors_heated"],
  ["Lusterka boczne składane elektrycznie", "door_mirrors_electrically_foldable"],
  ["Kamera w lusterku bocznym", "door_mirror_camera"],
  ["Asystent (czujnik) martwego pola", "blind_spot_warning"],
  ["Aktywny asystent zmiany pasa ruchu", "active_lane_change_assistant"],
  ["Lane assist - kontrola zmiany pasa ruchu", "lane_control_assistant"],
  ["Kontrola odległości od poprzedzającego pojazdu", "distance_control"],
  ["Ogranicznik prędkości", "speed_limiter"],
  ["Asystent hamowania - Brake Assist", "brake_assist"],
  ["Asystent pokonywania zakrętów", "curve_trace_assistant"],
  ["Kontrola trakcji", "traction_control"],
  ["Automatyczna kontrola zjazdu ze stoku", "hill_descent_control"],
  ["Wspomaganie ruszania pod górę- Hill Holder", "hill_holder"],
  ["Aktywne rozpoznawanie znaków ograniczenia prędkości", "active_speed_sign_recognition"],
  ["System rozpoznawania znaków drogowych", "traffic_sign_recognition"],
  ["Asystent zapobiegania kolizjom na skrzyzowaniu", "intersection_assist"],
  ["Autonomiczny system kierowania", "basic_autonomous_driving"],
  ["Asystent świateł drogowych", "automated_high_beam_assist"],
  ["Lampy doświetlające zakręt", "cornering_headlights"],
  ["Oświetlenie adaptacyjne", "adaptive_light"],
  ["Dynamiczne światła doświetlające zakręty", "dynamic_directional_lights"],
  ["Czujnik zmierzchu", "automatic_dimlight_activation"],
  ["Spryskiwacze reflektorów", "headlamp_wash"],
  ["Światła do jazdy dziennej", "daytime_running_lights"],
  ["Światła do jazdy dziennej diodowe LED", "led_daytime_running_lights"],
  ["Lampy przeciwmgielne", "fog_lamps"],
  ["Lampy przeciwmgielne w technologii LED", "led_fog_lamps"],
  ["Lampy tylne w technologii LED", "led_rear_lights"],
  ["Oświetlenie drogi do domu", "follow_me_home"],
  ["Oświetlenie wnętrza LED", "led_interior_lighting"],
  ["System Start/Stop", "startstop_system"],
  ["Elektroniczna kontrola ciśnienia w oponach", "tyre_pressure_control"],
  ["Elektryczny hamulec postojowy", "electric_parking_brake"],
  ["Wspomaganie kierownicy", "power_steering"],
  ["Blokada mechanizmu różnicowego", "limited_slip_differential_in_general"],
  ["Regulowany dyferencjał centralny", "selectable_central_differential_characteristics"],
  ["Asystent jazdy w korku", "traffic_jam_assist"],
].sort((a, b) => a[0].localeCompare(b[0]))

export const MULTIMEDIA_ARRAY = [
  ["Apple CarPlay", "apple_carplay"],
  ["Android Auto", "android_auto"],
  ["Interfejs Bluetooth", "bluetooth_interface"],
  ["Radio", "radio"],
  ["Zestaw głośnomówiący", "hands_free_system"],
  ["Gniazdo USB", "usb_in"],
  ["Ładowanie bezprzewodowe urządzeń", "wireless_device_charging"],
  ["System nawigacji satelitarnej", "navigation_system"],
  ["System nagłośnienia", "soundsystem"],
  ["Wyświetlacz typu Head-Up", "head_up_display"],
  ["Ekran dotykowy", "touchscreen_monitor"],
  ["Sterowanie funkcjami pojazdu za pomocą głosu", "voice_control_for_vehicle_functions"],
  ["Dostęp do internetu", "internet_access"],
].sort((a, b) => a[0].localeCompare(b[0]))

export const findTypeOfEquipment = (el: string) => {
  if(COMFORT_ARRAY.find(e => e[1] === el)){
    return "comfort"
  }
  if(ASSISTANT_ARRAY.find(e => e[1] === el)){
    return "assistant"
  }
  if(SECURITY_ARRAY.find(e => e[1] === el)){
    return "security"
  }
  if(MULTIMEDIA_ARRAY.find(e => e[1] === el)){
    return "audio"
  }
}
